import type { AudienceItem } from '@/components/audiences/audience-list-types';
import { mapAudienceUserCounts } from '@/components/audiences/map-audience-dto-to-details';
import type { AudienceDto } from '@/generated/korza-api-client/types.gen';

export function mapAudienceSummaryToItem(dto: AudienceDto): AudienceItem {
  const { targetUsersCount, totalUserbaseCount } = mapAudienceUserCounts(dto);

  return {
    id: dto.id,
    name: dto.name,
    targetUsersCount,
    totalUserbaseCount,
    sentCampaignsCount: dto.sentCampaignsCount,
    scheduledCampaignsCount: 0,
    averageCtr: dto.campaignAnalytics.averageCtr,
    averageConversionRate: dto.campaignAnalytics.averageConversionRate,
  };
}
